import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, HideScrollbar, LineClamp } from '../../global/commonStyle';
interface Props {
  isActive?: boolean;
  color?: string;
  isProjectOverview?: boolean;
  removeMargin?: boolean;
  hasBottomPadding?: boolean;
  isMessageDetail?: boolean;
}
const Icon = styled.div`
  width: 24px;
  height: 24px;
`;

export const MainDiv = styled.div`
  max-width: 350px;
  width: 100%;
  position: relative;
  ${mobile_xl(css`
    max-width: unset;
    width: unset;
  `)}
`;

const FolderRight = styled.div<Props>`
  padding: var(--space-0) var(--space-24);
  height: 100dvh;
  background: var(--background-secondary);
  display: flex;
  flex-direction: column;
  ${HideScrollbar}
  ${mobile_xl(css<Props>`
    padding: var(--space-0);
    height: calc(100dvh + 1px);
    ${({ removeMargin }) =>
      removeMargin &&
      css`
        margin-inline: -20px;
      `}
  `)}
  ${({ isProjectOverview, isMessageDetail }) =>
    (isProjectOverview || isMessageDetail) &&
    css`
      height: calc(100dvh - 47px);
      border-left: 0.5px solid var(--border-primary);
      ${mobile_xl(css`
        margin: var(--space-0);
        border-left: none;
      `)}
    `}
`;
const RightHeader = styled.div<Props>`
  ${FlexBetween}
  gap: var(--space-20);
  position: sticky;
  top: 0;
  z-index: var(--z-index-base);
  background-color: var(--background-secondary);
  padding: var(--space-16) var(--space-0) var(--space-16) var(--space-24);
  margin-left: -24px;
  .fillColor {
    path {
      stroke: var(--text-secondary);
    }
    &:hover {
      background-color: var(--neutral-secondary);
      border-radius: var(--border-radius-4);
    }
  }
  .back-arrow {
    display: none;
  }
`;
const HeaderText = styled.p`
  ${Typography.heading_md}
  margin: var(--space-0);
  color: var(--text-primary);
`;

const FolderDiv = styled.div<Props>`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  margin-bottom: var(--space-24);
  ${mobile_xl(css<Props>`
    padding: var(--space-4) var(--space-20)
      ${({ hasBottomPadding }) => (hasBottomPadding ? 'var(--space-80)' : 'var(--space-20)')};
    background: var(--background-secondary);
    gap: var(--space-12);
    margin-bottom: var(--space-0);
  `)}
`;
const Card = styled.div`
  ${AlignCenter}
  padding: var(--space-10) var(--space-12);
  gap: var(--space-12);
  border-radius: var(--border-radius-8);
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  cursor: pointer;
  &:hover {
    border: 0.5px solid var(--text-secondary);
    box-shadow: var(--shadow-card);
  }
  ${mobile_xl(css`
    border-radius: var(--border-radius-12);
    &:hover {
      border: 0.5px solid var(--border-primary);
      box-shadow: unset;
    }
  `)}
`;
const LeftCard = styled.div`
  width: 36px;
  height: 36px;
`;
const RightCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: var(--space-0);
  gap: var(--space-2);
  padding-left: var(--space-12);
  border-left: 0.5px solid var(--border-primary);
`;
const CardTitle = styled.h2`
  ${Typography.body_md_medium}
  margin: var(--space-0);
  color: var(--text-primary);
  ${LineClamp(1)}
  word-break: break-word;
`;
const CardDecs = styled.p`
  ${Typography.body_sm}
  color: var(--text-secondary);
  margin: var(--space-0);
  ${LineClamp(1)}
  word-break: break-word;
`;
const BreadSlash = styled.div`
  padding-block: var(--space-4);
  ${Typography.body_md}
  color: var(--text-primary);
  margin-inline: var(--space-2);
`;

const BredCrumbBlock = styled.div<Props>`
  padding: var(--space-4) var(--space-8);
  ${Typography.body_md}
  color: var(--text-primary);
  cursor: pointer;

  &:hover {
    color: var(--text-secondary);
  }

  ${(props: Props) =>
    props.isActive &&
    css`
      color: var(--brand-primary);
    `}
`;

const BreadCrumb = styled.div`
  display: flex;
`;

const BreadCrumbContent = styled.div`
  display: flex;
`;

const FileIconDiv = styled.div`
  position: relative;
  .file-text {
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 35%;
    left: 25%;
    width: 50%;
    font-weight: 700;
    color: var(--text-secondary);
  }
`;

export {
  Icon,
  RightHeader,
  HeaderText,
  FolderDiv,
  FolderRight,
  Card,
  RightCard,
  CardTitle,
  CardDecs,
  BreadSlash,
  BredCrumbBlock,
  BreadCrumb,
  BreadCrumbContent,
  LeftCard,
  FileIconDiv
};
